import React, {Children} from 'react';
import PropTypes from 'prop-types';
import {RenderHTML} from '@learningblocks/shared-components';
import {domToReact} from 'html-react-parser';
import cname from '../WidgetStyles';

const TAG = 'tag';

/**
 * SliderLabel:
 *  - To display SliderText
 */
export function SliderLabel(props) {
  const addClassName = (node) => {
    if (node.name === TAG) {
      return <p id={props.id} className={`${cname.text}`}>{domToReact(node.children)}</p>;
    } else {
      return <p id={props.id} className={`${cname.text}`}>Invalid Text</p>;
    }
  };

  if (props.text) {
    return <RenderHTML content={props.text} replace={addClassName} />;
  } else {
    return null;
  }
}

SliderLabel.propTypes = {
  /**
   * Text to display on top of Slider
   */
  text: PropTypes.string,
};

SliderLabel.defaultProps = {
  text: '',
};
